//#region src/util/async.ts
/**
* Creates an async iterator from a subscribe function that follows the observable pattern.
*
* @template T The type of values produced by the store.
* @param subscribe A function that subscribes to store updates. It receives a callback to be
*          called on each update, and returns an unsubscribe function.
* @returns An async generator that yields store values as they are produced.
*/
function createAsyncIteratorFromCallback(subscribe) {
	const queue = [];
	let unsubscribe = null;
	let resolveNext = null;
	const unsubscribeFunc = subscribe((value) => {
		if (resolveNext) {
			resolveNext({
				value,
				done: false
			});
			resolveNext = null;
		} else queue.push(value);
	});
	if (typeof unsubscribeFunc === "function") unsubscribe = unsubscribeFunc;
	return (async function* () {
		try {
			while (true) if (queue.length > 0) yield queue.shift();
			else yield await new Promise((resolve) => {
				resolveNext = (result) => {
					if (!result.done) resolve(result.value);
				};
			});
		} finally {
			if (unsubscribe) unsubscribe();
		}
	})();
}

//#endregion
export { createAsyncIteratorFromCallback };
//# sourceMappingURL=async.js.map